<ng-container>
  <h1>{{ config.data.service_title }}</h1>
  <p *ngIf="noDescriptionBox()" class="pr-2" [ngClass]="showPoiSearchNote() ? 'pb-2' : 'pb-5'" [ngStyle]="{'min-height': descriptionMinHeight}">{{ config.data.service_description }}</p>
  <p class="pb-1 pr-2" style="font-style: italic" *ngIf="showPoiSearchNote()">*Gentile cliente, se la sede da raggiungere è un Internet Exchange Provider o un data center, la invitiamo a utilizzare la funzione “Cerca POI” dal menu a tendina </p>
  <ng-content></ng-content>
  <div *ngIf="user" class="user-info">
    <!-- <p><i class="fas fa-external-link-alt mr-1" style="color: #007bff"></i><a
        href={{env.requestsLinkUrl}}{{env.funnelRequests}}>Access your requests</a></p> -->
    <p><i class="fas fa-user"></i> {{ user.username }}</p>
    <p><i class="fas fa-building"></i> {{ user.company }}</p>
  </div>
</ng-container>
